import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { MapPinOff, ArrowRight } from "lucide-react";
import { Button } from "../ui/button"; // Adjust path if necessary

export default function NotFound() {
  const [countdown, setCountdown] = useState(5);
  const navigate = useNavigate();

  useEffect(() => {
    // If countdown hits 0, redirect to the home page
    if (countdown === 0) {
      navigate("/");
      return;
    }

    // Set up a timer that decreases the countdown by 1 every second
    const timer = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    // Cleanup the timer when the component unmounts
    return () => clearInterval(timer);
  }, [countdown, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 transition-colors duration-500 dark:bg-slate-950 p-4">
      
      {/* Background ambient glowing blobs */}
      <div className="pointer-events-none fixed inset-0 bg-[radial-gradient(circle_at_top_right,rgba(34,211,238,0.05),transparent_40%),radial-gradient(circle_at_bottom_left,rgba(59,130,246,0.05),transparent_40%)] dark:bg-[radial-gradient(circle_at_top_right,rgba(34,211,238,0.1),transparent_40%),radial-gradient(circle_at_bottom_left,rgba(59,130,246,0.08),transparent_40%)]" />

      <div className="relative z-10 w-full max-w-md text-center animate-in zoom-in-95 duration-500">
        
        <div className="mx-auto mb-8 flex h-24 w-24 items-center justify-center rounded-full bg-slate-100 shadow-inner dark:bg-slate-900 ring-1 ring-slate-200 dark:ring-white/10">
          <MapPinOff className="h-12 w-12 text-cyan-500" strokeWidth={1.5} />
        </div>

        <h1 className="text-7xl font-black text-slate-900 dark:text-white mb-2">404</h1>
        <h2 className="text-2xl font-bold tracking-tight text-slate-800 dark:text-slate-200 mb-4">
          Dead End Reached
        </h2>
        
        <p className="text-slate-500 dark:text-slate-400 mb-8 leading-relaxed">
          The route you are looking for doesn't exist on our map. Don't worry, we're rerouting you back to the main highway.
        </p>

        {/* Real-time Countdown Box */}
        <div className="mx-auto mb-8 max-w-xs rounded-2xl border border-cyan-200 bg-cyan-50 p-4 dark:border-cyan-500/20 dark:bg-cyan-500/10">
          <p className="text-sm font-bold uppercase tracking-wider text-cyan-700 dark:text-cyan-400">
            Redirecting in <span className="text-lg mx-1">{countdown}</span> seconds...
          </p>
        </div>

        <Button 
          onClick={() => navigate("/")}
          className="w-full sm:w-auto py-6 px-8 text-base font-bold shadow-lg shadow-cyan-500/20 bg-cyan-600 hover:bg-cyan-700 text-white dark:bg-cyan-600 dark:hover:bg-cyan-500 transition-transform hover:-translate-y-0.5"
        >
          Go Home Now <ArrowRight className="ml-2 h-5 w-5" />
        </Button>

      </div>
    </div>
  );
}